import { z } from 'zod';
/** The Call tab's phone-bridge settings — personal, like a Pulse mailbox
 * connection, not a tenant-wide policy. `callingEnabled` is tenant-wide
 * (whether TWILIO_ACCOUNT_SID/AUTH_TOKEN/PHONE_NUMBER are set at all), not
 * personal — it just travels on this same response since the settings page
 * is where both are shown together. */
export const callSettingsResponseSchema = z.object({
    bridgePhoneNumber: z.string().nullable(),
    callingEnabled: z.boolean(),
});
export const updateCallSettingsInputSchema = z.object({
    bridgePhoneNumber: z
        .string()
        .trim()
        .min(7, 'Enter a full phone number, including country code.')
        .max(20),
});
export const callStatusSchema = z.enum(['initiated', 'ringing', 'in-progress', 'completed', 'failed', 'no-answer', 'busy', 'canceled']);
/** Same exclusive-arc shape `Call` itself uses (and `ActivityLink` before
 * it) — exactly one of the three, checked here so a malformed request 400s
 * with a clear message instead of reaching the exclusive-arc CHECK
 * constraint as an opaque database error. */
export const placeCallInputSchema = z
    .object({
    leadId: z.string().uuid().optional(),
    contactId: z.string().uuid().optional(),
    companyId: z.string().uuid().optional(),
})
    .refine((v) => [v.leadId, v.contactId, v.companyId].filter(Boolean).length === 1, {
    message: 'Exactly one of leadId, contactId or companyId is required.',
});
/** A Twilio phone-bridge call in progress or finished — polled by the Call
 * tab while `status` is non-terminal. Mirrors `Call` (packages/db/prisma/
 * schema.prisma), the operational/webhook-driven row; the user-facing
 * record is a plain `Activity`, created once the call reaches a terminal
 * status (`activityId` here, once set). */
export const callResponseSchema = z.object({
    id: z.string().uuid(),
    leadId: z.string().uuid().nullable(),
    contactId: z.string().uuid().nullable(),
    companyId: z.string().uuid().nullable(),
    status: callStatusSchema,
    toNumber: z.string(),
    bridgeNumber: z.string(),
    durationSeconds: z.number().int().nullable(),
    recordingUrl: z.string().nullable(),
    activityId: z.string().uuid().nullable(),
    startedAt: z.string().datetime(),
    endedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=schemas.js.map